export default "__VITE_ASSET__kKxOhw7G__"